module.exports = __webpack_public_path__ + "img/YR.903fb4c1.png";